import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { chargeChairRentalPayment } from '../actions';
import ChairRentalChargeableAmount from '../components/ChairRentalChargeableAmount';
import withToggle from '../../../../common/hoc/withToggle';
import confirmModal from '../../../../common/confirmModal';
import withNotifications from '../../../../common/withNotifications';
import { t } from '../../../../../modules/infra/i18n';

const mapDispatchToProps = {
  chargeChairRentalPayment,
};

// Store translation key instead of calling t() at module level
const MODAL_MESSAGE_KEY = 'barber:chair_rental.chargeable.modal_message';

export default compose(
  connect(null, mapDispatchToProps),
  withNotifications,
  withToggle(),
  withHandlers({
    markAsPaidOrCharge: props => () => confirmModal({
      title: '',
      message: t(MODAL_MESSAGE_KEY), // ✅ t() called at runtime
      type: 'default',
      confirmButtonText: t('barber:chair_rental.chargeable.charge_button'),
      negativeButtonText: t('barber:chair_rental.chargeable.mark_paid_button'),
    },
    () => props.chargeChairRentalPayment(props.barberId, props.payment.id)
      .then(() => props.addNotification({
        level: 'success',
        message: t('barber:chair_rental.chargeable.charge_success'),
        title: t('barber:chair_rental.form.success_title'),
      }))
      .then(() => props.off())
      .catch(() => props.off()),

    () => props.chargeChairRentalPayment(props.barberId, props.payment.id, { markAsPaid: true })
      .then(() => props.addNotification({
        level: 'success',
        message: t('barber:chair_rental.chargeable.mark_paid_success'),
        title: t('barber:chair_rental.form.success_title'),
      }))
      .then(() => props.off())
      .catch(() => props.off()),
      () => props.off(),
    ),
  })
)(ChairRentalChargeableAmount);
